// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/';
import { Divider, Space } from 'antd';
import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';

const DividerSeries = (): ReactElement => {
    const i = useLocalMessage();
    return (
        <Divider>
            <Space>
                <ICONS.ApartmentOutlined className="color-primary" />
                <span className="title-3b color-primary">{i('dashboard.form-divider.series')}</span>
            </Space>
        </Divider>
    );
};

export default DividerSeries;
